/**
 * Pronto Posto – Maildaten-Index.
 *
 * Aufteilung: mail/<sprache>/<episode>.js  (language/episode, NICHT episode/language).
 * Grund: geteilte Inhalte – z. B. eine generische Spam-Mail, die in jeder deutschen Episode
 * auftaucht – sind innerhalb EINER Sprache über Episoden hinweg geteilt. Dafür gibt es
 * pro Sprache ein ./_shared.js. Umgekehrt (episode/language) hätte das keinen Platz.
 *
 * Jedes Episodenmodul exportiert getEmails() und getSpam(). Beide werden bei jedem Request
 * neu aufgerufen, damit Werte aus dem localStorage (Rätselwerte) aktuell bleiben.
 *
 * Regeln:
 * - Eine Mail gehört genau einer Sprache. Postfachadressen dürfen sich zwischen Sprachen
 *   NICHT überschneiden (jede Sprache hat eigene Accounts, eigene IDs).
 * - IDs sind global eindeutig; die Reservierungen stehen in den Blockkommentaren der
 *   Episodenmodule.
 *
 * Reihenfolge von MAIL_SETS: 1:1 wie in der historischen Sammeldatei, damit der
 * ausgelieferte Datensatz nach dem Umbau exakt derselbe ist. Funktional ist die Reihenfolge
 * unerheblich – email.js filtert pro Postfach und sortiert anschliessend nach Zeit.
 */
import * as deDE from './de-DE'
import * as enGB from './en-GB'
import * as frFR from './fr-FR'
import * as itIT from './it-IT'
import * as esES from './es-ES'

export const languages = {
  'de-DE': deDE,
  'en-GB': enGB,
  'fr-FR': frFR,
  'it-IT': itIT,
  'es-ES': esES
}

const MAIL_SETS = [
  deDE.shared,
  deDE.ks02,
  deDE.ks03,
  enGB.ks03,
  itIT.ks03,
  deDE.ks04,
  enGB.ks04,
  frFR.ks04,
  itIT.ks04,
  esES.ks04
]

function collect(getter) {
  return MAIL_SETS.reduce(
    (all, set) => all.concat(typeof set[getter] === 'function' ? set[getter]() : []),
    []
  )
}

export function getAllEmails() {
  return collect('getEmails')
}

export function getAllSpam() {
  return collect('getSpam')
}
